import { Component, OnInit } from '@angular/core';
import {Person} from '../person';

@Component({
  selector: 'app-test-page',
  templateUrl: './test-page.component.html',
  styleUrls: ['./test-page.component.scss']
})
export class TestPageComponent implements OnInit {

  public people: Person[]
  public person2: Person

  constructor() {
    this.people = [new Person('James','james@peach.co'),new Person( 'Samuel','sam@perkins.ca')];
    this.person2 = new Person()
  }

  ngOnInit() {
  }

  handleChange(){
    console.log(this.people)
  }
  printPerson1(){
    console.log(this.people)
  }


}
